/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import faqSectionStyle from "./faqSectionStyle";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const FaqSection = () => {
  return (
    <Container sx={faqSectionStyle.section}>
      <Box sx={faqSectionStyle.scrollToAnchor} id="fragen">
        {" "}
      </Box>
      <Typography variant={"h2"}>Häufige Fragen - einfach für Sie erklärt</Typography>
      <Grid container alignItems={"stretch"}>
        <Grid item xs={12} sm={12} md={4} sx={faqSectionStyle.gridItem}>
          <Paper sx={faqSectionStyle.content} elevation={4}>
            <Typography variant={"h4"} sx={faqSectionStyle.title}>
              Wie ist der Ablauf bei einer Scheidung?
            </Typography>
            <Box sx={faqSectionStyle.description}>
              <p>
                Grundvoraussetzung ist, dass Sie voneinander getrennt leben und zwar mindestens ein Jahr (Trennungsjahr). Das kann auch im selben Wohnraum
                geschehen, vorausgesetzt Sie teilen sich kein gemeinsames Schlafzimmer mehr.
              </p>
              <p>
                Nun müssen Themen wie Sorgerecht, Unterhalt und Vermögensverteilung geklärt werden. Bestenfalls einigen Sie sich darüber direkt mit Ihrem
                Partner, damit hohe Anwaltskosten gespart werden. Wenn Sie sich mit dem Partner einig sind, reichen wir die Scheidung für Sie ein und Sie können
                sich scheiden lassen.
              </p>
              <p>Wir begleiten Sie bei all diesen Schritten und wir sorgen dafür, dass Sie möglichst schnell und kostengünstig geschieden werden.</p>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={4} sx={faqSectionStyle.gridItem}>
          <Paper sx={faqSectionStyle.content} elevation={4}>
            <Typography variant={"h4"} sx={faqSectionStyle.title}>
              Wie viel kostet eine Scheidung?
            </Typography>
            <Box sx={faqSectionStyle.description}>
              <p>
                Die Kosten für eine Scheidung basieren größtenteils auf den Einkommen der Ehepartner. Im Durchschnitt kostet eine Scheidung zwischen 1.500 und
                2.500 EUR.
              </p>
              <p>Allgemein gilt: je weniger der Anwalt tätig werden muss, desto günstiger wird die Scheidung.</p>
              <p>
                Wir sichern Ihnen die kostengünstigste Scheidung zu, indem wir nur die gesetzliche Mindestgebühr berechnen! In Ihrer Servicewelt können Sie die
                genauen Kosten leicht berechnen lassen und haben jederzeit vollen Überblick über Kosten und Zahlverfahren.
              </p>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={4} sx={faqSectionStyle.gridItem}>
          <Paper sx={faqSectionStyle.content} elevation={4}>
            <Typography variant={"h4"} sx={faqSectionStyle.title}>
              Wie funktioniert eine Scheidung bei Legalbird?
            </Typography>
            <Box sx={faqSectionStyle.description}>
              <p>
                Scheidung einfach, schnell und professionell: Sie geben in Ihrer Servicewelt alle wichtigen Daten zu Ihrer Scheidung an und wir als
                spezialisierte{" "}
                <strong>
                  <Link to={"/scheidung/scheidungsanwalt"}>Scheidungsanwälte</Link>
                </strong>{" "}
                erstellen den Scheidungsantrag für Sie, der dann bei Gericht eingereicht wird. Wir sind Fachanwälte im Familienrecht und kümmern uns direkt um
                Ihre Scheidung, ohne dass ein weiterer Anwalt für Ihren Partner nötig ist. Das erspart Ihnen viel Zeit und hohe Kosten.
              </p>
              <p>
                Sie finden bei uns in der Servicewelt eine detaillierte Kostenübersicht, aktuelle Informationen und ausführliche Ratgeber, damit Sie immer den
                Überblick über den aktuellen Status Ihrer Scheidung haben.
              </p>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Box sx={faqSectionStyle.spacerDiv} />
    </Container>
  );
};

export default FaqSection;
